import { Routes, Route } from "react-router-dom";
import Nav from "./components/Nav";
import Home from "./page/Home";
import All from "./components/All";
import Footer from "./components/Footer";

function App() {
  return (
    <>
      <Nav />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/all" element={<All />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;